<script lang="ts">
    import Opacity from '../../../shared/Opacity.svelte';
    import DisplayLabel from '../../Jobs/DisplayLabel.svelte';

    export let label: string;
    export let text: string;
    export let subtext: string;
    export let flexColumn: boolean = false;
</script>

{#if label || text || subtext}
    <div class="display-address" class:flexColumn>
        {#if flexColumn}
            <div
                class="city bold"
                class:flexColumn
                style="flex: 0 0 auto; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; "
            >
                <span>{text.trim()}</span>
            </div>
            <div
                class="street light"
                class:flexColumn
                style="flex: 0 1 auto; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; "
            >
                <span>{subtext.trim()}</span>
            </div>
        {:else}
            <div
                class="street light"
                class:flexColumn
                style="flex: 0 1 auto; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; "
            >
                <span>{label.trim()}</span>
            </div>
        {/if}
    </div>
{:else}
    <div class="city bold">
        <Opacity>(brak adresu)</Opacity>
    </div>
{/if}

<style>
    .display-address {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        /*column-gap: 3px;*/
        width: 100%;
    }

    .display-address.flexColumn {
        flex-direction: column;
        padding: 2px 0;
    }

    .display-address .city.flexColumn {
        width: 100%;
    }

    .display-address .street.flexColumn {
        width: 100%;
    }
</style>
